var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.896,
    height: 12.41,
    viewBox: "0 0 13.896 12.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning-fill",
    transform: "translate(-1.249 -1.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11539",
    "data-name": "Path 11539",
    d: "M29.726,34.172,24.267,24.74a1.49,1.49,0,0,0-2.578,0h0L16.23,34.172a1.489,1.489,0,0,0,1.289,2.235H28.437a1.489,1.489,0,0,0,1.289-2.235Zm-7.245-5.211a.5.5,0,0,1,.993,0v2.482a.5.5,0,1,1-.993,0Zm.5,5.461a.745.745,0,1,1,.745-.745.745.745,0,0,1-.745.745Z",
    transform: "translate(-14.78 -22.127)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.947ce36f0b1202b13cba047fc67b5342.svg";
export { ForwardRef as ReactComponent };